export default __webpack_public_path__ + "static/media/logo-olistik.5ca14035.webp";